import React from "react";
import { Col, Row } from "react-bootstrap";
import image1 from "../Assets/images/seo_page.jpeg";
const SearchEngine = () => {
  return (
    <div className="main_search margin_top">
      <div className="banner_section_search">
      <div className="container-layout">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <h1 className='text-center'>Search Engine Optimization</h1>
                                <p className='text-center'>
                                Search Engine Optimization (SEO) is a set of strategies and practices aimed at improving the visibility and ranking of a website or web page in search engine results. The primary goal of SEO is to increase organic (non-paid) traffic to a website from search engines like Google, Bing, and Yahoo.
                                </p>

                            
                            </div>

                        </div>
                    </div>
                    
      
      </div>
      <div className="second_section">
        <div className="container-layout">
          <Row>
            <Col xl={12}>
              <div className="left_second">
                <p className="heading_best">
                  BEST WEB DESIGNING COMPANY IN ABOHAR{" "}
                </p>
                <h3>Search Engine Optimization</h3>
                <Row className="row_second_section">
                  <Col xl={6} lg={7}>
                    <div className="left_second">
                      <p className="when_txt">
                        Most online users start their session by looking for
                        something, which they are something in need. The
                        internet is the best place to meet their needs when it
                        comes to getting info about something they relate to or
                        want to know about like finding a restaurant, clothing,
                        shoes, or any kind of business. It means that there is a
                        lot of competition in the market related to everything.
                        Every online business needs to stay on the top of the
                        search engine so that when any person searches about it,
                        then it may become available to them at any cost.
                      </p>
                      <p className="when_txt">
                        To get a website indexed and ranked on search engines,
                        SEO is the process that can help. SEO is the technique,
                        which helps your customers to get connected with the
                        business online. We, at Gs Infotech Web Solutions, have a team
                        of SEO executives, who analyze the website of our
                        clients and apply some modern SEO techniques and
                        strategies to increase the rankings and making the
                        websites come on Google’s first page.
                      </p>
                      <p className="when_txt">
                        We are the best ones in terms of SEO because our
                        solutions are backed by the excellent and result-driven
                        practices and we use long-tail phrases and examined
                        keywords to let the traffic come to your website
                      </p>

                      <div className="new_ul">
                        <ul className="ul_lists">
                          <li><span></span>Create a new, engaging website</li>

                          <li><span></span>Redesign existing website</li>
                          <li><span></span>Maintain and transform websites</li>
                        </ul>

                        <ul className="ul_lists">
                          <li><span></span>Make a website mobile-friendly</li>
                          <li><span></span>Add e-commerce to websites</li>
                          <li><span></span>Customized web development</li>
                        </ul>
                      </div>
                    </div>
                  </Col>
                  <Col xl={6} lg={5}>
                    <div className="image_section_div">
                      <img src={image1} alt="image1" />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default SearchEngine;
